import React from "react";
import useRouter from "../../hooks/useRouter";
export default function Link(props) {
    const { to } = props;
    const [, setRouter] = useRouter();
    return (React.createElement("a", { href: props.to, style: props.style, className: props.className, onClick: (e) => {
            if (props.onClick)
                props.onClick(e);
            if (!to.startsWith("http")) {
                e.preventDefault();
                setRouter.changeLocation(to);
            }
        } }, props.children));
}
